<template>
    <div class="row align-items-center text-center">
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/budairport.webp" type="image/webp">
                <source srcset="../../images/partners/budairport.png" type="image/png">
                <img src="../../images/partners/budairport.png" alt="Budapest Airport" class="img-fluid" width="400" height="178" loading="lazy">
            </picture>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/fordpetranyi.webp" type="image/webp">
                <source srcset="../../images/partners/fordpetranyi.png" type="image/png">
                <img src="../../images/partners/fordpetranyi.png" alt="Ford Petrányi" class="img-fluid" width="400" height="178" loading="lazy">
            </picture>
        </div>
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <a href="https://grandsoft.hu" target="_blank" rel="noopener" title="Egyedi szoftverfejlesztés, programozás, weboldal- és webáruház-készítés">
                <picture>
                    <source srcset="../../images/partners/grandsoft.webp" type="image/webp">
                    <source srcset="../../images/partners/grandsoft.png" type="image/png">
                    <img src="../../images/partners/grandsoft.png" alt="GrandSoft egyedi szoftverfejlesztés, programozás" class="img-fluid" width="400" height="135" loading="lazy">
                </picture>
            </a>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/city_sightseeing_budapest.webp" type="image/webp">
                <source srcset="../../images/partners/city_sightseeing_budapest.png" type="image/png">
                <img src="../../images/partners/city_sightseeing_budapest.png" alt="City Sightseeing Budapest" class="img-fluid" width="255" height="99" loading="lazy">
            </picture>
        </div>
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/austrian.webp" type="image/webp">
                <source srcset="../../images/partners/austrian.png" type="image/png">
                <img src="../../images/partners/austrian.png" alt="Austrian Airlines" class="img-fluid" width="400" height="178" loading="lazy">
            </picture>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/bftk.webp" type="image/webp">
                <source srcset="../../images/partners/bftk.png" type="image/png">
                <img src="../../images/partners/bftk.png" alt="BFTK" class="img-fluid" width="400" height="178" loading="lazy">
            </picture>
        </div>
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/brussels.webp" type="image/webp">
                <source srcset="../../images/partners/brussels.png" type="image/png">
                <img src="../../images/partners/brussels.png" alt="Brussels Airlines" class="img-fluid" width="400" height="178" loading="lazy">
            </picture>
        </div>
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/lufthansa.webp" type="image/webp">
                <source srcset="../../images/partners/lufthansa.png" type="image/png">
                <img src="../../images/partners/lufthansa.png" alt="Lufthansa" class="img-fluid" width="400" height="177" loading="lazy">
            </picture>
        </div>
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/swiss.webp" type="image/webp">
                <source srcset="../../images/partners/swiss.png" type="image/png">
                <img src="../../images/partners/swiss.png" alt="SWISS" class="img-fluid" width="400" height="177" loading="lazy">
            </picture>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/bp_card_72_plus.webp" type="image/webp">
                <source srcset="../../images/partners/bp_card_72_plus.png" type="image/png">
                <img src="../../images/partners/bp_card_72_plus.png" alt="Budapest Card 72 plus" class="img-fluid" width="400" height="127" loading="lazy">
            </picture>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/bp_card.webp" type="image/webp">
                <source srcset="../../images/partners/bp_card.png" type="image/png">
                <img src="../../images/partners/bp_card.png" alt="Budapest Card" class="img-fluid" width="400" height="127" loading="lazy">
            </picture>
        </div>
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/emirates.webp" type="image/webp">
                <source srcset="../../images/partners/emirates.png" type="image/png">
                <img src="../../images/partners/emirates.png" alt="Emirates" class="img-fluid" width="250" height="250" loading="lazy">
            </picture>
        </div>
        <div class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/budapest.webp" type="image/webp">
                <source srcset="../../images/partners/budapest.png" type="image/png">
                <img src="../../images/partners/budapest.png" alt="Emirates" class="img-fluid" width="250" height="250" loading="lazy">
            </picture>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/guide_me.webp" type="image/webp">
                <source srcset="../../images/partners/guide_me.png" type="image/png">
                <img src="../../images/partners/guide_me.png" alt="Guide me Budapest" class="img-fluid" width="400" height="147" loading="lazy">
            </picture>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/castle_bus.webp" type="image/webp">
                <source srcset="../../images/partners/castle_bus.png" type="image/png">
                <img src="../../images/partners/castle_bus.png" alt="Budapest Castle Bus" class="img-fluid" width="400" height="202" loading="lazy">
            </picture>
        </div>
        <div v-if="false" class="col-6 col-sm-4 mb-3 mb-md-0">
            <picture>
                <source srcset="../../images/partners/hopon.webp" type="image/webp">
                <source srcset="../../images/partners/hopon.png" type="image/png">
                <img src="../../images/partners/hopon.png" alt="Hop On Hop Off Budapest" class="img-fluid" width="400" height="400" loading="lazy">
            </picture>
        </div>
    </div>
</template>
